let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kYYcq")).then(() => parcelRequire('cVVWH'));